import CardCounter from 'components/CardCounter';
import React, { useCallback, useEffect, useState } from 'react'
import { getLandingPage } from 'services/apiRoutes';
import IcDesa from 'assets/icons/ic-chain.png'
// import IcForm from 'assets/icons/ic-form.png'
import IcKab from 'assets/icons/ic-kab.png'

export default function RegisteredCounter() {
   const [joined, setJoined] = useState();

   const joinedAPI = useCallback(async () => {
     const res = await getLandingPage();
     const { data } = res;
     setJoined(data);
   }, []);

   useEffect(() => {
     joinedAPI();
   }, [joinedAPI]);

  return (
    <div className="relative px-5 py-32 space-y-16 bg-transparent wrapper xl:px-99">
      <h1 className="text-3xl font-bold text-center">
        Mereka Para Penggerak dan Geulanggang-Panah
      </h1>
      <div className="relative items-center py-24 space-y-8 overflow-hidden border justify-evenly xl:px-20 xl:space-y-0 md:flex mainWrapper border-borderCardFeatures rounded-2xl">
        <div className="absolute left-0 rounded-full shadow -z-[1] top-1/2  w-[130px] h-[130px] orangeElipse" />
        <div className="absolute right-0 rounded-full shadow -z-[1] top-1/2  w-[130px] h-[130px] greenElipse" />

        <CardCounter
          icon={IcDesa}
          label="Desa Tergabung"
          counter={joined?.jumlahKel}
          width={82.92}
          height={82.92}
        />
        {/* <CardCounter
          icon={IcForm}
          label="Desa Terdaftar"
          counter="546 Desa"
          width={72.29}
          height={72.33}
        /> */}
        <CardCounter
          icon={IcKab}
          label="Total Kabupaten"
          counter={joined?.jumlahKab}
          width={79.17}
          height={82.97}
        />
      </div>
    </div>
  );
}
